module.exports = __webpack_public_path__ + "img/Log-out-red.deb36d4.svg";